import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BannerService {
  public visible: boolean = false;
  public link: string = "";

  setRequiredData(visible: boolean, link: string): void {
    this.visible = visible;
    this.link = link;
  }
}